angular.module('task-project')
    .directive('taskProjectStatusPicker', function () {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                required: "=",
                modelType: '=',
                onChange: "&",
                initialValue: "=?"
            },
            template: `
                <div class="input-group input-group-sm" ng-class="{ 'filter-style': filterStyle }">
                    <span ng-if="!filterStyle" class="input-group-addon"><i class="fa fa-archive fa-fw"></i> </span>
                    <ui-select theme="select2" ng-model="selected" search-enabled="false" class="select2-label-container" ng-required="required" on-select="onSelectionChanged($item, $model)" on-remove="onSelectionChanged($item)">
                        <ui-select-match allow-clear placeholder="-- wybierz status --">
                            <task-project-status-label status="$select.selected"></task-project-status-label>
                        </ui-select-match>
                        <ui-select-choices repeat="t in items | filter: $select.search track by $index">
                            <task-project-status-label status="t"></todo-status-label>
                        </ui-select-choices>
                    </ui-select>
                </div>
            `,
            link: function (scope, $element, $attrs, ngModelCtrl) {
                scope.executeOnChange = scope.onChange || angular.noop
                scope.modelTypeR = scope.modelType || "object"

                scope.items = ['ON_TIME', 'RISKY', 'DELAYED', 'SUSPENDED', 'FINISHED']
                if(scope.initialValue != null && typeof scope.initialValue === "string"){
                    scope.selected = scope.items.find(i => i.name === scope.initialValue)
                    scope.onSelectionChanged(scope.selected, scope.selected)
                }

                ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => scope.modelTypeR === "id" ? viewValue.id : viewValue)

                scope.onSelectionChanged = ($item, $model) => {
                    ngModelCtrl.$setViewValue($item)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                    if(angular.isFunction(scope.executeOnChange())){
                        scope.executeOnChange()($item)
                    }
                }
            }
        }
    })
